import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ModalCompAdvance } from "../../Ui/ModalComp";
import { TextInputComp, FormikTextAreaComp } from "../..";
import InvestorPortalActionButton from "./InvestorPortalActionButton";

const schema = Yup.object({
  date: Yup.string().required("Date is required"),
  time: Yup.string().required("Time is required"),
  location: Yup.string().required("Location is required"),
  assignedStaffId: Yup.string(),
  note: Yup.string(),
});

function staffLabel(staff) {
  return `${staff?.first_name || ""} ${staff?.last_name || ""}`.trim() || staff?.email || `Staff #${staff?.id}`;
}

export default function InspectionScheduleModal({
  show,
  request,
  onClose,
  onSubmit,
  staffOptions = [],
}) {
  if (!request) return null;

  const initialStaffId =
    request.inspection?.assignedStaffId != null
      ? String(request.inspection.assignedStaffId)
      : request.assignedStaffId != null
        ? String(request.assignedStaffId)
        : "";

  const initial = {
    date: request.inspection?.date || "",
    time: request.inspection?.time || "10:00",
    location: request.inspection?.location || request.realEstate?.location || "",
    note: request.inspection?.note || "",
    assignedStaffId: initialStaffId,
  };

  const body = (
    <Formik
      initialValues={initial}
      validationSchema={schema}
      onSubmit={async (values) => {
        const selected = staffOptions.find((s) => String(s.id) === String(values.assignedStaffId));
        await onSubmit({
          ...values,
          assignedStaffId: values.assignedStaffId || undefined,
          assignedStaffName: selected ? staffLabel(selected) : undefined,
        });
      }}
      enableReinitialize
    >
      {({ isSubmitting, values, setFieldValue, errors, touched }) => (
        <Form>
          <TextInputComp label="Inspection date" name="date" type="date" />
          <TextInputComp label="Time" name="time" type="time" />
          <TextInputComp label="Location / meeting point" name="location" />
          <div className="mb-3">
            <label className="form-label small fw-semibold" htmlFor="inspection-assigned-staff">
              Assigned staff
            </label>
            <select
              id="inspection-assigned-staff"
              className="form-select"
              value={values.assignedStaffId}
              onChange={(e) => setFieldValue("assignedStaffId", e.target.value)}
            >
              <option value="">Select staff…</option>
              {staffOptions.map((s) => (
                <option key={s.id} value={s.id}>
                  {staffLabel(s)}
                </option>
              ))}
            </select>
            {touched.assignedStaffId && errors.assignedStaffId ? (
              <div className="text-danger small mt-1">{errors.assignedStaffId}</div>
            ) : null}
            <p className="text-muted small mb-0 mt-1">
              Staff list uses the first page of company staff.
            </p>
          </div>
          <FormikTextAreaComp label="Note" name="note" rows={2} />
          <div className="d-flex gap-2 justify-content-end mt-3">
            <InvestorPortalActionButton
              btnText="Cancel"
              type="button"
              variant="ghost"
              fullWidth={false}
              onClick={onClose}
            />
            <InvestorPortalActionButton
              btnText={isSubmitting ? "Saving…" : "Save schedule"}
              type="submit"
              variant="primary"
              fullWidth={false}
              disabled={isSubmitting}
            />
          </div>
        </Form>
      )}
    </Formik>
  );

  return (
    <ModalCompAdvance
      show={show}
      handleClose={onClose}
      modalTitle="Schedule property inspection"
      close
      size="md"
      centered
      arrayComp={[{ component: body }]}
    />
  );
}
